<router-outlet>
    <app-spinner></app-spinner>
</router-outlet>
<app-terms-dialog
  [visible]="termsModalVisible"
  (accepted)="onTermsAccepted()"
  (closed)="termsModalVisible = false"
></app-terms-dialog>
